import { useEffect, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (prop: any) => {
  const [state, setState] = useState(prop);

  useEffect(() => {
    if (state !== prop) {
      setState(prop);
    }
  }, [prop]);

  return [state, setState];
};
